module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Katherine Garbera\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Katherine Garbera is a "), _c('I', [_vm._v("USA TODAY")]), _vm._v(" bestselling author of more than 100 novels, which have been translated into over two dozen languages and sold millions of copies worldwide. She is the mother of two incredibly creative and snarky grown children, Katherine enjoys champagne, reading, walking and traveling with her husband. Visit her on the web at "), _c('a', {
    attrs: {
      "href": "http://www.katherinegarbera.com"
    }
  }, [_vm._v("www.katherinegarbera.com")]), _vm._v(".")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ltyPdm/tc-custom/9781488046988.jpg?1718046750886",
      "alt": "This image is the cover for the book One Night to Risk It All"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("One Night to Risk It All\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An F1 driver’s life spins out of control after a New Year’s Eve fling with an influencer in this romance by a "), _c('i', [_vm._v("USA Today")]), _vm._v("–bestselling author.")]), _c('br'), _c('br'), _vm._v("Family honor demands payback. "), _c('i', [_vm._v("He craves so much more . . . ")]), _c('br'), _c('br'), _vm._v("Formula One champion Inigo Velasquez loves fast cars—and faster women. Yet one night with socialite Marielle Bisset has his brakes screeching. She’s beautiful . . . and the woman who hurt his sister. To Inigo’s family, Marielle’s the ultimate adversary. In his bed, the sultry enigma is so much more. Inigo is used to winning—but can he win Marielle without losing his family?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0